// Readiness-card UI strings.

import type { MsgSection } from "./types.js";

export const readiness: MsgSection = {
  "readiness.accept": { en: "Accept", de: "Übernehmen" },
  "readiness.acceptLocked": {
    en: "Accept unlocks once every field is verified",
    de: "Übernehmen geht erst, wenn alle Felder belegt sind",
  },
  "readiness.verdict.green": { en: "verified", de: "belegt" },
  "readiness.verdict.unverified": { en: "unverified", de: "nicht belegt" },
  "readiness.verdict.needsInput": { en: "needs input", de: "Eingabe nötig" },
  "readiness.verdict.skipped": { en: "skipped", de: "übersprungen" },
  "readiness.verdict.retry": { en: "retry", de: "erneut" },
  // Sits under the Definition of Done on the card — the one green LOOM authors
  // for itself. The Focus review screen's `focus.refine.ready.dodNote` says the
  // same thing but points at its in-place editor; this card has none, so it
  // names the correction it can actually offer.
  "readiness.dodNote": {
    en: "Loom set this quality bar itself. Accepting writes it to the issue — tell Loom in chat if it doesn’t fit.",
    de: "Diesen Qualitätsanspruch hat Loom selbst festgelegt. Mit Übernehmen wird er ins Issue geschrieben — sag es Loom im Chat, wenn er nicht passt.",
  },
  // The issue card HOLDS an answer (a click on Loom's answer, or a typed Send)
  // and sends every held answer as one turn — one message per click would kill
  // the running turn each time.
  "readiness.answerHeld": {
    en: "Goes to Loom with your other answers",
    de: "Geht mit deinen anderen Antworten an Loom",
  },
  "readiness.answerSent": { en: "Sent — Loom is checking it", de: "Gesendet — Loom prüft es" },
  "readiness.undo": { en: "Undo", de: "Rückgängig" },
  // The accessible name: the card holds up to six rows, each with its own Undo.
  "readiness.undoAria": { en: "Undo ({label})", de: "Rückgängig ({label})" },
  "readiness.sendNow": { en: "Send now", de: "Jetzt senden" },
  // A row's own label, quoted, inside a sentence under that row ("Loom wrote
  // this version of “I want”") — the card labels are sentence fragments.
  "readiness.quotedLabel": { en: "“{label}”", de: "„{label}“" },
  // The hold WAITS on a working agent: a message that lands mid-turn kills the
  // turn, and a first turn often runs past a minute. (The backstop behind it
  // only bounds a busy flag that never clears — five minutes, not a promise.)
  "readiness.holdBusy": {
    en: "Loom is still working — your answers go out when it’s done.",
    de: "Loom arbeitet noch — deine Antworten gehen raus, sobald es fertig ist.",
  },
  "readiness.loadingMilestones": { en: "Loading milestones…", de: "Meilensteine werden geladen…" },
  "readiness.milestonesError": { en: "Couldn't load milestones.", de: "Meilensteine liessen sich nicht laden." },
};
